import type { DisciplineScheduleSetupLessonsPayload } from '../model/interfaces'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleSetupLessonsApiOptions {
  disciplineId: string | number
  payload: DisciplineScheduleSetupLessonsPayload
  successMessage: string
}

/** `POST /admin-api/disciplines/{discipline}/schedule/setup-lessons` — books unscheduled lessons on the weekly
 *  schedule from the start date; runs inside the request. */
export const useDisciplineScheduleSetupLessonsApi = async (
  options: DisciplineScheduleSetupLessonsApiOptions,
): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.setup-lessons', { discipline_id: options.disciplineId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.post(url, options.payload)
    toast.success({ title: 'Success!', description: options.successMessage })

    return true
  } catch (err: unknown) {
    toast.error({ title: 'Error!', description: getAxiosErrorMessage(err) })
    return false
  }
}
